import React, { useState } from "react";
import { useRecoilState, useResetRecoilState } from "recoil";
import Modal from "../../modules/layout/Modal";
import Select from "../../atoms/input/Select";
import { isPresetAddModalOpenState } from "../../../recoil/admin/examRoom";
import { categoryOption, speakLanguageOption } from "../../../static";
import ComboSelect from "./ComboSelect";
import useQuestionActions from "../../../api/hooks/admin/question";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  presetRoomTypeState,
  selectedPresetComboListState,
} from "../../../recoil/admin/preset";
import usePresetActions from "../../../api/hooks/admin/preset";

const AdminPresetAddModal = () => {
  const [isPresetAddModalOpen, setIsPresetAddModalOpen] = useRecoilState(
    isPresetAddModalOpenState
  );

  const [title, setTitle] = useState("");
  const resetSelectedComboList = useResetRecoilState(
    selectedPresetComboListState
  );

  const [selectedComboList, setSelectedComboList] = useRecoilState(
    selectedPresetComboListState
  );

  const [roomType, setRoomType] = useRecoilState(presetRoomTypeState);
  const resetRoomType = useResetRecoilState(presetRoomTypeState);

  const { fetchComboList } = useQuestionActions();
  const { createPreset } = usePresetActions();

  const { data: comboList } = useQuery({
    queryKey: ["fetchComboList"],
    queryFn: () => fetchComboList(),
    onSuccess: () => {
      console.log(comboList);
    },
  });

  const queryClient = useQueryClient();

  const mutation = useMutation(createPreset, {
    onSuccess: (context) => {
      if (context.status === 200) {
        queryClient.invalidateQueries("fetchPresetList");
        resetSelectedComboList();
        resetRoomType();
        setIsPresetAddModalOpen(false);
      }
    },
    onError: () => {
      alert("실패");
    },
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    const nextSelectedComboList = [...selectedComboList].sort();

    if (nextSelectedComboList.length === 5)
      mutation.mutate({
        title,
        room_type: roomType,
        combo_sn1: nextSelectedComboList[0],
        combo_sn2: nextSelectedComboList[1],
        combo_sn3: nextSelectedComboList[2],
        combo_sn4: nextSelectedComboList[3],
        combo_sn5: nextSelectedComboList[4],
      });
    else alert("5개를 선택해야 합니다.");
  };

  return (
    <>
      <Modal isOpen={isPresetAddModalOpen}>
        <div className="modal fade" id="url" style={{ display: "block" }}>
          <div className="modal-content">
            <div className="modal-header flex">
              <div className="modal-title">
                <p>문항 프리셋</p>
              </div>
            </div>
            <form onSubmit={handleSubmit}>
              <div className="modal-body confirm-sec">
                <div className="modal-title">
                  <p>프리셋 추가</p>
                </div>
                <div className="plus-box">
                  <p className="plus-title">프리셋 이름</p>
                  <input
                    type="text"
                    className="plus-title-input"
                    value={title}
                    onChange={(e) => setTitle(e.target.value)}
                    style={{ width: "100%" }}
                  />
                </div>
                <div className="plus-box">
                  <p className="plus-title">시험유형 선택</p>
                  <Select
                    placeholder="선택"
                    options={speakLanguageOption}
                    value={roomType}
                    style={{ width: "100px" }}
                    onChange={(e) => setRoomType(e.target.value)}
                  />
                </div>
                <ComboSelect />
                <div className="modal-footer text-align-right">
                  <button
                    type="button"
                    className="modal-btn modal-close-btn"
                    onClick={() => {
                      resetSelectedComboList();
                      resetRoomType();
                      setIsPresetAddModalOpen(false);
                    }}
                  >
                    닫기
                  </button>
                  <button type="submit" className="modal-btn modal-save-btn">
                    완료
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default AdminPresetAddModal;
